export const TRAINING_VALIDATION_FIELDS = [
  "name",
  "location_address",
  "lat",
  "lng",
  "location_radius",
  "payroll_amount",
  "number_of_days",
  "description",
  "starts_at",
  "ends_at",
  "before_check_in_margin",
  "after_check_in_margin",
  "before_check_out_margin",
  "after_check_out_margin",
];
